<ng-container *ngIf="dataIsAvailable()">
  <div class="labelsXAxes">
    <label *ngFor="let label of xLabels" class="xLabelStyle">{{label}}</label>
  </div>
</ng-container>
<div class="Flexbox">
  <gen-overlay-loader class="loader" *ngIf="!dataIsAvailable()" [showOverlay]="false"></gen-overlay-loader>
  <ng-container *ngIf="dataIsAvailable()">
    <div class="labelsYAxes">
      <label *ngFor="let label of yLabels" class="yLabel">{{label}}</label>
    </div>
  </ng-container>

  <div class="grid-container">
    <ng-container *ngIf="dataIsAvailable()">
      <div *ngFor="let id of getArray(97) | slice:1;" class="canvas-container">
        <canvas baseChart
                [data]="getDataScore(id)"
                [options]="lineChartOptions()"
                [chartType]="lineChartType"
                [colors]="graphColor"
                [labels]="getDataLabels(id)"
                [legend]="false"
                style="width:4.78rem;height:2.85rem">
        </canvas>
      </div>
    </ng-container>
  </div>
</div>

